// Mismo patron que Factura/cotizacionTemplate.js: HTML completo como
// string, inyectado en un iframe (ver OrdenEntregaPrintModal.jsx) y
// llenado via window.renderOrdenEntrega(data). No lleva precios -- es
// un documento de despacho, no fiscal ni comercial (A6).
const ordenEntregaTemplateHtml = `<!DOCTYPE html>
<html lang="es">
<head>
    <meta charset="UTF-8">
    <meta name="viewport" content="width=device-width, initial-scale=1.0">
    <title>OE-XXXX</title>
    <style>
        * { margin: 0; padding: 0; box-sizing: border-box; }

        body {
            font-family: "Arial", Times, serif;
            font-size: 12px;
            line-height: 1.3;
            color: #000;
            background: #fff;
            padding: 15px;
        }

        .document {
            width: 100%;
            max-width: 800px;
            margin: 0 auto;
            padding: 20px;
        }

        .header-company-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;
        }

        .company-section {
            display: flex;
            flex-direction: column;
            align-items: flex-start;
            width: 50%;
        }

        .header {
            text-align: right;
            font-size: 12px;
            font-weight: bold;
            line-height: 1.6;
        }

        .header-row { display: flex; justify-content: flex-end; align-items: center; margin-bottom: 3px; }
        .header-label { font-weight: bold; margin-right: 5px; }
        .field-value { font-family: "Arial", Times, serif; font-size: 12px; color: #000; display: inline-block; min-width: 20px; }
        .header-value { width: 140px; text-align: left; font-weight: bold; }

        .client-section { margin: 15px 0; width: 100%; }
        .client-row-container { display: flex; justify-content: space-between; margin-bottom: 4px; }
        .client-data-left { width: 55%; }
        .client-contact-right { width: 43%; text-align: left; }
        .client-row { margin-bottom: 3px; display: flex; align-items: flex-start; }
        .client-label { font-weight: bold; font-size: 11px; white-space: nowrap; margin-right: 5px; flex-shrink: 0; }
        .client-value { width: 100%; display: inline-block; }

        .title { text-align: center; font-size: 18px; font-weight: bold; margin: 20px 0 6px 0; letter-spacing: 2px; }
        .subtitle { text-align: center; font-size: 12px; font-weight: bold; margin-bottom: 15px; color: #b45309; }

        table { width: 100%; border-collapse: collapse; margin: 15px 0; font-size: 11px; }
        th { background-color: #f5f5f5; border: none; padding: 6px 5px; text-align: left; font-weight: bold; font-size: 10px; border-bottom: 1px solid #000; }
        td { padding: 5px; vertical-align: top; border-bottom: 1px solid #808382; }
        .col-desc { width: 34%; text-align: left; }
        .col-unidad { width: 10%; text-align: center; }
        .col-pedida { width: 14%; text-align: center; }
        .col-entregada { width: 14%; text-align: center; font-weight: bold; }
        .col-pendiente { width: 14%; text-align: center; }
        .col-ubicacion { width: 14%; text-align: left; }

        .resumen-row { text-align: right; font-size: 11px; margin-top: 8px; }
        .resumen-row strong { font-weight: bold; }

        .firma-section { margin-top: 60px; display: flex; justify-content: space-between; gap: 30px; }
        .firma-box { flex: 1; text-align: center; font-size: 11px; }
        .firma-linea { border-top: 1px solid #000; margin-bottom: 4px; padding-top: 4px; }

        .note-section { margin-top: 20px; font-size: 10px; font-style: italic; color: #555; }

        .field-value:empty::before { content: attr(data-placeholder); color: #666; opacity: 0.6; font-style: italic; }

        @media print {
            body { padding: 0; font-size: 11px; }
            .document { padding: 15px; max-width: 100%; }
            .no-print { display: none !important; }
        }

        .action-bar { text-align: right; margin-bottom: 20px; padding: 10px; background: #f8f9fa; border-radius: 8px; display: flex; justify-content: flex-end; gap: 10px; }
        .btn { padding: 8px 16px; border: none; border-radius: 4px; cursor: pointer; font-weight: bold; font-size: 13px; }
        .btn-print { background: #3b82f6; color: white; }
        .btn-download { background: #10b981; color: white; }
    </style>
    <script src="https://cdnjs.cloudflare.com/ajax/libs/html2pdf.js/0.10.1/html2pdf.bundle.min.js"></script>
</head>
<body>
    <div class="action-bar no-print" id="action-bar">
        <button class="btn btn-print" onclick="window.print()">Imprimir</button>
        <button class="btn btn-download" onclick="window.descargarPDF()">Descargar PDF</button>
    </div>

    <div class="document" id="oe-document">
        <div class="header-company-row">
            <div class="company-section">
                <img id="company-logo" src="/Logo GAMAN.png" alt="Logo Empresa"
                    style="max-width: 320px; max-height: 100px; width: 100%; object-fit: contain; object-position: left;">
            </div>
            <div class="header">
                <div class="header-row">
                    <span class="header-label">OE:</span>
                    <span class="field-value header-value" id="oe-numero" data-placeholder="N°"></span>
                </div>
                <div class="header-row">
                    <span class="header-label">FECHA:</span>
                    <span class="field-value header-value" id="oe-fecha" data-placeholder="DD/MM/AAAA"></span>
                </div>
                <div class="header-row">
                    <span class="header-label">COTIZACIÓN:</span>
                    <span class="field-value header-value" id="oe-cotizacion" data-placeholder="COT-0000"></span>
                </div>
                <div class="header-row" id="row-factura">
                    <span class="header-label">FACTURA:</span>
                    <span class="field-value header-value" id="oe-factura" data-placeholder="—"></span>
                </div>
                <div class="header-row" id="row-solicitud">
                    <span class="header-label">SOLICITUD:</span>
                    <span class="field-value header-value" id="oe-solicitud" data-placeholder="—"></span>
                </div>
            </div>
        </div>

        <div class="client-section">
            <div class="client-row-container">
                <div class="client-data-left">
                    <div class="client-row">
                        <span class="client-label">Cliente:</span>
                        <span class="field-value client-value" id="cli-nombre" data-placeholder="Cliente / Empresa"></span>
                    </div>
                    <div class="client-row">
                        <span class="client-label">RIF/CI:</span>
                        <span class="field-value client-value" id="cli-rif" data-placeholder="J-12345678-9"></span>
                    </div>
                    <div class="client-row">
                        <span class="client-label">Dirección:</span>
                        <span class="field-value client-value" id="cli-direccion" data-placeholder="—"></span>
                    </div>
                </div>
                <div class="client-contact-right">
                    <div class="client-row">
                        <span class="client-label">Teléfono:</span>
                        <span class="field-value client-value" id="cli-telefono" data-placeholder="—"></span>
                    </div>
                    <div class="client-row">
                        <span class="client-label">Vía:</span>
                        <span class="field-value client-value" id="oe-via" data-placeholder="—"></span>
                    </div>
                    <div class="client-row">
                        <span class="client-label">Entrega estimada:</span>
                        <span class="field-value client-value" id="oe-fecha-estimada" data-placeholder="—"></span>
                    </div>
                </div>
            </div>
        </div>

        <div class="title">ORDEN DE ENTREGA</div>
        <div class="subtitle" id="oe-subtitulo" style="display:none;"></div>

        <table>
            <thead>
                <tr>
                    <th class="col-desc">Descripción</th>
                    <th class="col-unidad">Unidad</th>
                    <th class="col-pedida">Cant. Pedida</th>
                    <th class="col-entregada" id="th-entregada">Cant. Entregada</th>
                    <th class="col-pendiente">Pendiente</th>
                    <th class="col-ubicacion">Ubicación</th>
                </tr>
            </thead>
            <tbody id="oe-items-body">
            </tbody>
        </table>

        <div class="resumen-row" id="oe-resumen"></div>

        <div class="note-section">
            Documento de despacho, sin valor fiscal ni comercial. No incluye precios.
        </div>

        <div class="firma-section">
            <div class="firma-box">
                <div class="firma-linea" id="firma-nombre">&nbsp;</div>
                Recibido por (Nombre)
            </div>
            <div class="firma-box">
                <div class="firma-linea" id="firma-cedula">&nbsp;</div>
                C.I.
            </div>
            <div class="firma-box">
                <div class="firma-linea">&nbsp;</div>
                Firma
            </div>
            <div class="firma-box">
                <div class="firma-linea" id="firma-fecha">&nbsp;</div>
                Fecha
            </div>
        </div>
    </div>

    <script>
        window.renderOrdenEntrega = function(data) {
            const set = (id, value) => {
                const el = document.getElementById(id);
                if (el && value !== undefined && value !== null && value !== '') el.textContent = value;
            };
            const hideIfEmpty = (rowId, value) => {
                const el = document.getElementById(rowId);
                if (el && !value) el.style.display = 'none';
            };

            set('oe-numero', data.numero);
            set('oe-fecha', data.fecha);
            set('oe-cotizacion', data.cotizacion_numero);
            set('oe-factura', data.factura_numero);
            set('oe-solicitud', data.solicitud_folio);
            hideIfEmpty('row-factura', data.factura_numero);
            hideIfEmpty('row-solicitud', data.solicitud_folio);

            set('cli-nombre', data.cliente_nombre);
            set('cli-rif', data.cliente_rif);
            set('cli-direccion', data.cliente_direccion);
            set('cli-telefono', data.cliente_telefono);
            set('oe-via', data.via_entrega);
            set('oe-fecha-estimada', data.fecha_estimada_entrega);

            if (data.es_parcial) {
                const subtitulo = document.getElementById('oe-subtitulo');
                subtitulo.style.display = 'block';
                subtitulo.textContent = 'ENTREGA PARCIAL' + (data.numero_confirmacion ? ' #' + data.numero_confirmacion : '');
                document.getElementById('th-entregada').textContent = 'Entregado hoy';
            }

            const tbody = document.getElementById('oe-items-body');
            (data.items || []).forEach(item => {
                const tr = document.createElement('tr');
                tr.innerHTML =
                    '<td class="col-desc">' + (item.descripcion || '') + (item.es_servicio ? ' <em>(servicio)</em>' : '') + '</td>' +
                    '<td class="col-unidad">' + (item.unidad || '-') + '</td>' +
                    '<td class="col-pedida">' + item.cantidad_pedida + '</td>' +
                    '<td class="col-entregada">' + item.cantidad_mostrar + '</td>' +
                    '<td class="col-pendiente">' + item.pendiente + '</td>' +
                    '<td class="col-ubicacion">' + (item.ubicacion || '-') + '</td>';
                tbody.appendChild(tr);
            });

            set('oe-resumen', data.resumen);

            if (data.receptor_nombre) {
                document.getElementById('firma-nombre').textContent = data.receptor_nombre;
                document.getElementById('firma-cedula').textContent = data.receptor_cedula || '';
                document.getElementById('firma-fecha').textContent = data.fecha_confirmacion || '';
            }
        };

        window.descargarPDF = function() {
            const element = document.getElementById('oe-document');
            const opt = {
                margin: [0.4, 0.4, 0.4, 0.4],
                filename: document.title + '.pdf',
                image: { type: 'jpeg', quality: 0.98 },
                html2canvas: { scale: 2, useCORS: true },
                jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
            };
            if (typeof html2pdf !== 'undefined') {
                html2pdf().set(opt).from(element).save();
            }
        };
    </script>
</body>
</html>`;

export default ordenEntregaTemplateHtml;
